export const flatten = array => {
    if (array.length === 0) {
        return array;
    }
    if (Array.isArray(array[0])) {
        return flatten(array[0]).concat(flatten(array.slice(1)));
    }
    return [array[0]].concat(flatten(array.slice(1)));
};
